module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_6005.97ba7b5a.png";